export function initCustomerSuccessDropdown() {
  const $dropdown = $("#cs-view-dropdown");

  if ($dropdown.length === 0) return;

  $dropdown.off("change.csDropdown");

  $dropdown.on("change.csDropdown", function (e) {
    e.preventDefault();
    e.stopPropagation();

    const $select = $(this);
    const selectedUrl = $select.val() as string;
    const $selectedOption = $select.find("option:selected");

    if (!selectedUrl || $selectedOption.is(":disabled")) {
      return false;
    }

    const view = $selectedOption.data("view") || "customers";
    const filter = $selectedOption.data("filter") || "";
    const tags = $selectedOption.data("tags") || "";
    const hiddenFieldValue = $("#full_screen").val();
    const sidebarHidden = $(".sidebar-column").hasClass("d-none");
    const urlParams = new URLSearchParams(window.location.search);
    const urlHasFullScreen = urlParams.get('full_screen') === 'true';

    const isFullScreen = hiddenFieldValue === "true" || (hiddenFieldValue === undefined && (sidebarHidden || urlHasFullScreen));

    $(".spinner-wrapper .spinner-border").removeClass("d-none");
    $('#customer-content').css({ opacity: '0.5', 'pointer-events': 'none' });

    let ajaxUrl: string;
    const ajaxData: any = {};

    if (isFullScreen) {
      ajaxData.full_screen = "true";
    }

    if (view === "my_clients") {
      ajaxUrl = "/customer_success/my_clients";
    } else if (view === "my_tasks") {
      ajaxUrl = "/customer_success/my_tasks";
    } else {
      ajaxUrl = "/customer_success/customers";
      if (filter) {
        ajaxData.filter = filter;
      }
      if (tags) {
        ajaxData.tags_contain = tags;
      }
    }

    $('#clear-search, #full-screen-toggle, #cs-view-dropdown').prop('disabled', true);
    $('#customer-search-form').find('.search-field, input[type="submit"]').prop('disabled', true);

    $.ajax({
      url: ajaxUrl,
      type: "GET",
      dataType: "script",
      data: ajaxData,
      success: function () {
        if (history.replaceState) {
          const newUrl = new URL(selectedUrl, window.location.origin);
          if (isFullScreen) {
            newUrl.searchParams.set('full_screen', 'true');
          }
          history.replaceState(null, "", newUrl.pathname + newUrl.search);
        }
        $(".spinner-wrapper .spinner-border").addClass("d-none");
        $('#customer-content').css({ opacity: '1', 'pointer-events': 'auto' });

        $('#clear-search, #full-screen-toggle, #cs-view-dropdown').prop('disabled', false);
        $('#customer-search-form').find('.search-field, input[type="submit"]').prop('disabled', false);
      },
      error: function () {
        console.error("Error switching view");
        alert("Failed to switch view. Please try again.");
        $(".spinner-wrapper .spinner-border").addClass("d-none");
        $('#customer-content').css({ opacity: '1', 'pointer-events': 'auto' });

        $('#clear-search, #full-screen-toggle, #cs-view-dropdown').prop('disabled', false);
        $('#customer-search-form').find('.search-field, input[type="submit"]').prop('disabled', false);
      }
    });
    return false;
  });
}

function updateDropdownCounts(currentView: string) {
}
